import React from 'react';

const PaymentDetailContext = React.createContext({ paymentDetail: {}, updatePaymentData: () => {}, createNewPaymentMethod: () => {}, message: '', updateMessage: () => {} });

export default PaymentDetailContext;